import { SignatureStyleTypeEnum } from '@/components';
import { ControllerBase } from '@/utils/bizify';

interface PageData {
  textSign: string;
  signStyle: string;
  loading: boolean;
  activityKey: string;
  isBegin: boolean;
}

export class PageCtrl extends ControllerBase<PageData> {
  protected $data(): PageData {
    return {
      textSign: '',
      signStyle: '',
      loading: false,
      activityKey: SignatureStyleTypeEnum.TYPE,
      isBegin: false
    };
  }

  $onCreated = ({ textSign }: { textSign: string }): void => {
    console.log('create', textSign);
    this.setTextSign(textSign);
  };

  setTextSign = (text: string): void => {
    this.state.textSign = text;
  };

  setSignStyle = (text: string): void => {
    this.state.signStyle = text;
  };

  setLoading = (loading: boolean): void => {
    this.state.loading = loading;
  };

  setActivityKey = (key: string): void => {
    this.state.activityKey = key;
  };

  setIsBegin = (isBegin: boolean): void => {
    this.state.isBegin = isBegin;
  };

  handleBeginStroke = (): void => {
    if (!this.state.isBegin) {
      this.state.isBegin = true;
    }
  };

  handleEndStroke = (): void => {
    if (this.state.isBegin) {
      this.state.isBegin = false;
    }
  };
}
